import { render, staticRenderFns } from "./insertTerm.vue?vue&type=template&id=eed0bace&"
import script from "./insertTerm.vue?vue&type=script&lang=js&"
export * from "./insertTerm.vue?vue&type=script&lang=js&"
import style0 from "./insertTerm.vue?vue&type=style&index=0&id=eed0bace&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports